import { BILLING_EMAIL, PARTNERSHIPS_EMAIL, SECURITY_EMAIL, SUPPORT_EMAIL } from "@/lib/contactEmails";
import { ContactMailLink } from "@/components/ContactMailLink";

/** Shared help/contact strip for billing, settings, and integrations. */
export function SupportContactStrip({ variant = "general", className = "" }) {
    if (variant === "billing") {
        return (
            <p className={`text-xs leading-relaxed text-white/45 ${className}`} data-testid="support-contact-billing">
                Billing or subscription questions?{" "}
                <ContactMailLink email={BILLING_EMAIL} /> · General support:{" "}
                <ContactMailLink email={SUPPORT_EMAIL} />
            </p>
        );
    }

    if (variant === "integrations" || variant === "connections") {
        return (
            <p className={`text-xs leading-relaxed text-white/45 ${className}`} data-testid="support-contact-connections">
                Connection or webhook help: <ContactMailLink email={PARTNERSHIPS_EMAIL} /> · Account support:{" "}
                <ContactMailLink email={SUPPORT_EMAIL} />
            </p>
        );
    }

    if (variant === "security") {
        return (
            <p className={`text-xs leading-relaxed text-white/45 ${className}`} data-testid="support-contact-security">
                Lost access to 2FA or suspect an incident? Contact{" "}
                <ContactMailLink email={SUPPORT_EMAIL} /> or report security issues to{" "}
                <ContactMailLink email={SECURITY_EMAIL} />.
            </p>
        );
    }

    return (
        <p className={`text-xs leading-relaxed text-white/45 ${className}`} data-testid="support-contact-general">
            Need help? <ContactMailLink email={SUPPORT_EMAIL} />
        </p>
    );
}
